module.exports = __webpack_public_path__ + "static/media/haven.92c3e82b.png";